module.exports = __webpack_public_path__ + "img/binary.468f5b4c.svg";